import React from "react";
import {
    Typography,
    Box,
    Button,
    Card,
    CardContent,
    Grid,
    Divider,
    Chip,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";

import {
    Person,
    Business,
    LocationOn,
    Phone,
    Email,
    Receipt,
    LocalGasStation,
    PropaneTank,
    Badge,
    Warning,
    Explore,
    RequestQuote,
    Factory,
    Feed
} from "@mui/icons-material";

import moment from "moment"
import FactibilidadesSisvenIdForm from "./FactibilidadesSisvenIdForm";

export default function FactibilidadDetalle({ cliente, domicilio, precios, factibilidad, artefactos, muestraForm }) {

    const InfoRow = ({ icon, label, value }) => (
        <Box sx={{ display: "flex", alignItems: "center", mb: 1.5 }}>
            <Box
                sx={{
                    mr: 2,
                    color: "#1976d2",
                    display: "flex",
                    alignItems: "center",
                }}
            >
                {icon}
            </Box>
            <Box>
                <Typography variant="caption" sx={{ color: "#666", display: "block" }}>
                    {label}
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 500, color: "#333" }}>
                    {value || "-"}
                </Typography>
            </Box>
        </Box>
    );

    const SectionHeader = ({ icon, title, subtitle }) => (
        <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
            <Box
                sx={{
                    backgroundColor: "#1976d2",
                    borderRadius: "12px",
                    p: 1.5,
                    mr: 2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                {React.cloneElement(icon, { sx: { color: "#fff", fontSize: 24 } })}
            </Box>
            <Box>
                <Typography variant="h6" sx={{ fontWeight: 600, color: "#1a1a2e" }}>
                    {title}
                </Typography>
                {subtitle && (
                    <Typography variant="caption" sx={{ color: "#666" }}>
                        {subtitle}
                    </Typography>
                )}
            </Box>
        </Box>
    );

    return (
        <div>
            <>
                <Box sx={{ backgroundColor: "#f5f7fa", minHeight: "100vh" }}>
                    <Box
                        sx={{
                            background: "linear-gradient(135deg, #1976d2 0%, #1565c0 100%)",
                            py: 1.5,
                            px: 3,
                            mb: 2,
                        }}
                    >
                        <Box sx={{ maxWidth: 1400, mx: "auto" }}>
                            <Typography
                                variant="h6"
                                sx={{ color: "#fff", fontWeight: 400, mb: 0.5 }}
                            >
                                Información De Factibilidad
                            </Typography>
                            <Typography
                                variant="body1"
                                sx={{
                                    fontSize: 25,
                                    fontWeight: 800,
                                    color: "rgba(255,255,255,0.85)",
                                    cursor: "pointer",
                                    "&:hover": { textDecoration: !muestraForm ? "underline" : "none" },
                                }}
                                onClick={() => !muestraForm && window.open(`/#/clientes/profile/${cliente?.id}/datos`, "_blank")}
                            >
                                {cliente?.razon_social || "Cargando..."} {cliente.sisven_id ? `(${cliente.sisven_id})` : ` `}
                            </Typography>
                        </Box>
                    </Box>
                    <Box sx={{ maxWidth: 1400, mx: "auto", px: 3, pb: 6 }}>
                        <Grid container spacing={3}>
                            {factibilidad?.id_tipofact === 235 && (
                                <Grid item xs={12}>
                                    <Card
                                        elevation={0}
                                        sx={{
                                            borderRadius: 3,
                                            border: "1px solid #e0e0e0",
                                            overflow: "visible",
                                        }}
                                    >
                                        <CardContent sx={{ p: 4 }}>
                                            <SectionHeader
                                                icon={<Receipt />}
                                                title="Datos de Facturación"
                                                subtitle="Información fiscal del nuevo cliente."
                                            />
                                            <Grid container spacing={3} direction="row">
                                                <Grid item xs={12} md={3}>
                                                    <InfoRow
                                                        icon={<Person />}
                                                        label="Razón Social"
                                                        value={cliente?.razon_social}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={3}>
                                                    <InfoRow
                                                        icon={<Badge />}
                                                        label="CUIT"
                                                        value={cliente?.cuit}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={3}>
                                                    <InfoRow
                                                        icon={<Receipt />}
                                                        label="Condición IVA"
                                                        value={cliente?.sit_iva}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={3}>
                                                    <InfoRow
                                                        icon={<RequestQuote />}
                                                        label="Condición PAGO"
                                                        value={cliente?.condicion || "No registrada"}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} md={3}>
                                                    <InfoRow
                                                        icon={<LocationOn />}
                                                        label="Dirección Fiscal"
                                                        value={`${cliente?.direccion_fiscal}, ${cliente?.localidad}, ${cliente?.provincia}`}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} md={3}>
                                                    <InfoRow
                                                        icon={<Business />}
                                                        label="Empresa"
                                                        value={cliente?.empresa}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} md={3}>
                                                    <InfoRow
                                                        icon={<Factory />}
                                                        label="Sucursal"
                                                        value={cliente?.suc || "No registrada."}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} md={3}>
                                                    <InfoRow
                                                        icon={<Feed />}
                                                        label="Segmento"
                                                        value={cliente?.segmento || "No registrada."}
                                                    />
                                                </Grid>



                                                <Grid item xs={12} md={6}>
                                                    <InfoRow
                                                        icon={<Email />}
                                                        label="Email"
                                                        value={cliente?.mails}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <InfoRow
                                                        icon={<Phone />}
                                                        label="Teléfonos"
                                                        value={[
                                                            cliente?.telefono1,
                                                            cliente?.telefono2,
                                                            cliente?.telefono3,
                                                        ]
                                                            .filter(Boolean)
                                                            .join(" / ")}
                                                    />
                                                </Grid>
                                            </Grid>

                                            {
                                                !!precios && (
                                                    <>
                                                        <Divider sx={{ my: 3 }} />
                                                        <Box
                                                            sx={{
                                                                backgroundColor: "#fff3e0",
                                                                borderRadius: 2,
                                                                p: 3,
                                                                border: "1px solid #ffb74d",
                                                            }}
                                                        >

                                                            <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    gap: 2,
                                                                    flexWrap: "wrap",
                                                                    alignItems: "center",
                                                                    pb: 2,
                                                                }}
                                                            >
                                                                <Typography
                                                                    variant="subtitle1"
                                                                    sx={{
                                                                        fontWeight: 600,
                                                                        color: "#e65100",
                                                                        whiteSpace: "nowrap",
                                                                    }}
                                                                >
                                                                    Precios Vigentes del Segmento:  {cliente.segmento}
                                                                </Typography>
                                                                <Chip
                                                                    label={`Desde: ${precios ? moment(precios.vigencia).format("DD-MM-YYYY") : "N/D"}`}
                                                                    sx={{ backgroundColor: "#fff", fontWeight: 500 }}
                                                                />
                                                                <Chip
                                                                    label={`Hasta: ${precios ? moment(precios.vigencia_hasta).format("DD-MM-YYYY") : "N/D"}`}
                                                                    sx={{ backgroundColor: "#fff", fontWeight: 500 }}
                                                                />
                                                            </Box>
                                                            <Grid container direction="row" justifyContent="space-between">
                                                                <Grid item xs={5.8}
                                                                    sx={{
                                                                        backgroundColor: "#ff9800",
                                                                        borderRadius: 2,
                                                                        p: 2,
                                                                        textAlign: "center",
                                                                        height: "100%",
                                                                    }}
                                                                >
                                                                    <Typography
                                                                        variant="caption"
                                                                        sx={{ color: "rgba(255,255,255,0.9)", display: "block", mb: 0.5 }}
                                                                    >
                                                                        Precio por Litro (sin IVA)
                                                                    </Typography>
                                                                    <Typography
                                                                        variant="h5"
                                                                        sx={{ fontWeight: 700, color: "#fff" }}
                                                                    >
                                                                        $ {precios?.precio_litro_sin_iva || "N/D"}
                                                                    </Typography>
                                                                </Grid>
                                                                <Grid item xs={5.8}
                                                                    sx={{
                                                                        backgroundColor: "#ff9800",
                                                                        borderRadius: 2,
                                                                        p: 2,
                                                                        textAlign: "center",
                                                                        height: "100%",
                                                                    }}
                                                                >
                                                                    <Typography
                                                                        variant="caption"
                                                                        sx={{ color: "rgba(255,255,255,0.9)", display: "block", mb: 0.5 }}
                                                                    >
                                                                        Precio por Kilo (sin IVA)
                                                                    </Typography>
                                                                    <Typography
                                                                        variant="h5"
                                                                        sx={{ fontWeight: 700, color: "#fff" }}
                                                                    >
                                                                        $ {precios?.precio_kilo_sin_iva || "N/D"}
                                                                    </Typography>
                                                                </Grid>
                                                            </Grid>
                                                        </Box>


                                                    </>

                                                )
                                            }
                                        </CardContent>
                                    </Card>
                                </Grid>
                            )}
                            <Grid item xs={12} md={12}>
                                <Card
                                    elevation={0}
                                    sx={{ borderRadius: 3, border: "1px solid #e0e0e0", height: "100%" }}
                                >
                                    <CardContent sx={{ p: 4 }}>
                                        <SectionHeader
                                            icon={<LocationOn />}
                                            title="Dirección de Entrega"
                                            subtitle={factibilidad?.id_tipofact === 235 || factibilidad?.id_tipofact === 237 ? "Nuevo domicilio de entrega." : "Datos de domicilio existente (para ampliación)"}
                                        />
                                        <Grid container direction="row" spacing={3}>
                                            <Grid item xs={4}>
                                                <InfoRow
                                                    icon={<LocationOn />}
                                                    label="Dirección"
                                                    value={`${domicilio?.direccion_entrega}, ${domicilio?.localidad}, ${domicilio?.provincia} (${domicilio?.nombre_direccion})`}
                                                />
                                            </Grid>
                                            <Grid item xs={4}>
                                                <InfoRow
                                                    icon={<LocationOn />}
                                                    label="Sucursal"
                                                    value={`${domicilio?.sucursal}`}
                                                />
                                            </Grid>
                                            <Grid item xs={4}>
                                                <InfoRow
                                                    icon={<PropaneTank />}
                                                    label="Producto"
                                                    value={`${domicilio?.producto}`}
                                                />
                                            </Grid>
                                            <Grid item xs={4}>
                                                <InfoRow
                                                    icon={<Person />}
                                                    label="Contacto"
                                                    value={domicilio?.contacto}
                                                />
                                            </Grid>
                                            <Grid item xs={4}>
                                                <InfoRow
                                                    icon={<Email />}
                                                    label="Email"
                                                    value={domicilio?.mails}
                                                />
                                            </Grid>
                                            <Grid item xs={4}>
                                                <InfoRow
                                                    icon={<Phone />}
                                                    label="Teléfonos"
                                                    value={[
                                                        domicilio?.telefono1,
                                                        domicilio?.telefono2,
                                                        domicilio?.telefono3,
                                                    ]
                                                        .filter(Boolean)
                                                        .join(" / ")}
                                                />
                                            </Grid>
                                        </Grid>

                                        <Divider sx={{ my: 2 }} />

                                        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                                            <Explore color="error" /> Geolocalización:
                                            <Chip
                                                size="small"
                                                label={`Lat: ${domicilio?.latitud || "N/D"}`}
                                                variant="outlined"
                                            />
                                            <Chip
                                                size="small"
                                                label={`Long: ${domicilio?.longitud || "N/D"}`}
                                                variant="outlined"
                                            />
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid item xs={12} md={12}>
                                <Card
                                    elevation={0}
                                    sx={{ borderRadius: 3, border: "1px solid #e0e0e0", height: "100%" }}
                                >
                                    <CardContent sx={{ p: 4 }}>
                                        <SectionHeader
                                            icon={<PropaneTank />}
                                            title="Tanques"
                                            subtitle="Cantidad de tanques por capacidad."
                                        />
                                        <Grid container spacing={2}>
                                            {[
                                                { label: "0.5 m³", value: factibilidad?.canttk_05 },
                                                { label: "1 m³", value: factibilidad?.canttk_1 },
                                                { label: "2 m³", value: factibilidad?.canttk_2 },
                                                { label: "4 m³", value: factibilidad?.canttk_4 },
                                                { label: "7 m³", value: factibilidad?.canttk_7 },
                                            ].map((tank, index) => (
                                                <Grid item xs={6} sm={2.4} key={index}>
                                                    <Paper
                                                        elevation={0}
                                                        sx={{
                                                            p: 2,
                                                            textAlign: "center",
                                                            borderRadius: 2,
                                                            backgroundColor: tank.value
                                                                ? "#e8f5e9"
                                                                : "#f5f5f5",
                                                            border: tank.value
                                                                ? "1px solid #81c784"
                                                                : "1px solid #e0e0e0",
                                                        }}
                                                    >
                                                        <Typography
                                                            variant="h5"
                                                            sx={{
                                                                fontWeight: 700,
                                                                color: tank.value ? "#2e7d32" : "#999",
                                                            }}
                                                        >
                                                            {tank.value || 0}
                                                        </Typography>
                                                        <Typography
                                                            variant="caption"
                                                            sx={{ color: "#666", fontSize: 18 }}
                                                        >
                                                            {tank.label}
                                                        </Typography>
                                                    </Paper>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <Card
                                    elevation={0}
                                    sx={{ borderRadius: 3, border: "1px solid #e0e0e0", height: "100%" }}
                                >
                                    <CardContent sx={{ p: 4 }}>
                                        <SectionHeader
                                            icon={<LocalGasStation />}
                                            title="Artefactos"
                                            subtitle="Equipos registrados"
                                        />
                                        {artefactos && artefactos.length > 0 ? (
                                            <TableContainer>
                                                <Table size="small">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell sx={{ fontWeight: 600 }}>
                                                                Artefacto
                                                            </TableCell>
                                                            <TableCell align="right" sx={{ fontWeight: 600 }}>
                                                                Consumo Anual
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {artefactos.map((artefacto, index) => (
                                                            <TableRow key={index}>
                                                                <TableCell>{artefacto.artefacto}</TableCell>
                                                                <TableCell align="right">
                                                                    <Chip
                                                                        size="small"
                                                                        label={`${artefacto.consumoanual} KG`}
                                                                        color="primary"
                                                                        variant="outlined"
                                                                    />
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        ) : (
                                            <Typography variant="body2" sx={{ color: "#999" }}>
                                                No hay artefactos registrados
                                            </Typography>
                                        )}
                                    </CardContent>
                                </Card>
                            </Grid>

                            {factibilidad && (
                                <Grid item xs={12} md={12}>
                                    <Card
                                        elevation={0}
                                        sx={{ borderRadius: 3, border: "1px solid #e0e0e0", height: "100%" }}
                                    >
                                        <CardContent sx={{ p: 4 }}>
                                            <SectionHeader
                                                icon={<Receipt />}
                                                title="Conceptos a Facturar"
                                                subtitle="Montos pendientes de facturación"
                                            />
                                            {factibilidad.motivocli1 ? (
                                                <Paper
                                                    elevation={0}
                                                    sx={{
                                                        p: 3,
                                                        borderRadius: 2,
                                                        backgroundColor: "#e6f2ff",
                                                        border: "1px solid rgba(181, 216, 246, 0.41)",
                                                    }}
                                                >
                                                    <Typography
                                                        variant="body1"
                                                        sx={{ fontWeight: 600, color: "#000" }}
                                                    >
                                                        Motivo:
                                                    </Typography>

                                                    <Typography
                                                        variant="body1"
                                                        sx={{ fontWeight: 200, color: "#000" }}
                                                    >
                                                        {factibilidad.motivocli1}
                                                    </Typography>
                                                    <Typography
                                                        variant="h5"
                                                        sx={{ fontWeight: 700, color: "#000", mt: 1 }}
                                                    >
                                                        $ {factibilidad.cantmotivocli1}
                                                    </Typography>
                                                    <Typography variant="caption"
                                                        sx={{
                                                            pt: 1,
                                                            color: "#666",
                                                            fontSize: 14,
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: 0.5,
                                                        }}>
                                                        <Warning color="warning" /> No incluye impuestos
                                                    </Typography>
                                                </Paper>
                                            ) : (
                                                <Typography variant="body2" sx={{ color: "#999" }}>
                                                    No hay conceptos para facturar
                                                </Typography>
                                            )}
                                        </CardContent>
                                    </Card>
                                </Grid>
                            )}
                        </Grid>
                        {
                            muestraForm && !cliente.sisven_id && (
                                <Box sx={{ height: "120px" }} />
                            )
                        }
                    </Box>
                    {
                        muestraForm && !cliente.sisven_id && (
                            <FactibilidadesSisvenIdForm factibilidad={factibilidad} idCliente={cliente.id} />
                        )
                    }
                </Box>
            </>
        </div>
    );
}